import { Controller } from "@hotwired/stimulus"

// A brand's card in the Numbers inbox: a part of its rule marked "Not its
// number" shows as left out wherever it reads a number (the stores'
// spellings, the parts list), and each figure's number below becomes the one
// the next part kept gives it, before anything is settled.
export default class extends Controller {
  static targets = ["drop"]

  connect() {
    this.update()
  }

  update() {
    const dropped = new Set(this.dropTargets.filter((box) => box.checked).map((box) => box.value))
    this.element.querySelectorAll("[data-nb-line]").forEach((el) => {
      el.classList.toggle("nb-dropped", dropped.has(el.dataset.nbLine))
    })
    this.element.querySelectorAll("[data-nb-figure]").forEach((figure) => {
      let shown = null
      figure.querySelectorAll(".nb-cand").forEach((cand) => {
        const show = !shown && !dropped.has(cand.dataset.nbCandLine)
        cand.hidden = !show
        if (show) shown = cand
      })
      figure.querySelector(".nb-cand-none").hidden = Boolean(shown)
      const was = figure.querySelector(".nb-was")
      if (was) was.hidden = Boolean(shown) && was.dataset.now === shown.textContent
    })
  }
}
